import { useEffect } from 'react';

/**
 * Microsoft Clarity session replay & heatmaps.
 * Set VITE_CLARITY_PROJECT_ID in .env to enable.
 * Free, unlimited sessions: https://clarity.microsoft.com
 */
export function ClarityAnalytics() {
    const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID;

    useEffect(() => {
        if (!projectId) return;

        // Validate format to prevent script injection
        if (!/^[a-z0-9]+$/i.test(projectId)) return;

        // Avoid double-injection in dev strict mode
        if (document.querySelector('script[data-clarity]')) return;

        const script = document.createElement('script');
        script.setAttribute('data-clarity', 'true');
        script.async = true;
        script.text = `
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "${projectId}");
        `;
        document.head.appendChild(script);
    }, [projectId]);

    return null;
}
